module.exports = __webpack_public_path__ + "img/home-cases-3.fc330a2c.png";